import { Suspense, useMemo } from 'react'

import type { LoadingStyle } from 'src/shared/components/ui/miscellaneous/loading'
import { Loading } from 'src/shared/components/ui/miscellaneous/loading'

interface GenericSuspenseProps {
  children: React.ReactNode
  name?: string
  style?: LoadingStyle
  customFallback?: React.ReactNode
  color?: string
}

export const GenericSuspense = ({ children, style = 'minimal', customFallback }: GenericSuspenseProps) => {
  const fallback = useMemo(() => {
    if (customFallback) return customFallback
    return <Loading style={style} />
  }, [customFallback, style])

  return <Suspense fallback={fallback}>{children}</Suspense>
}
